module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P21"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('p', {
    staticClass: "P24"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("Earlier versions of chapters, or parts of chapters, have appeared as follows. The editors and publishers are gratefully acknowledged. ")]), _c('span', {
    attrs: {
      "href": "#/html/09_3__The_Silence_of_the_Canon__Foe#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(": in "), _c('em', [_vm._v("Decolonizing Tradition: New Views of 20th-Century “British” Literature")]), _vm._v(", ed. Karen Lawrence (Champagne/Urbana: University of Illinois Press, 1991), 212–38, copyright "), _c('em', [_vm._v("©")]), _vm._v(" 1992 by the Board of Trustees of the University of Illinois; "), _c('span', {
    attrs: {
      "href": "#/html/10_4__Trusting_the_Other__Age_of_Ir#page_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 4")]), _vm._v(": in “The Writings of J. M. Coetzee,” ed. Michael Valdez Moses, special issue of "), _c('em', [_vm._v("The South Atlantic Quarterly")]), _vm._v(" 93 (1994): 59–82, copyright "), _c('em', [_vm._v("©")]), _vm._v(" 1994 by Duke University Press; "), _c('span', {
    attrs: {
      "href": "#/html/11_5__Expecting_the_Unexpected__The#page_113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 5")]), _vm._v(": in "), _c('em', [_vm._v("Applying: To Derrida")]), _vm._v(", ed. John Brannigan, Ruth Robbins, and Julian Wolfreys (London: Macmillan, 1996), 21–40, reproduced with permission of Palgrave Macmillan; "), _c('span', {
    attrs: {
      "href": "#/html/12_6__Confessing_in_the_Third_Perso#page_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 6")]), _vm._v(": in “South African Writing at the Crossroads,” ed. Nahem Yousaf and Graham Pechey, special issue of "), _c('em', [_vm._v("Critical Survey")]), _vm._v(" 11, no. 2 (1999): 77–93, copyright "), _c('em'), _vm._v("© Critical Survey and Berghahn Books, 1999; "), _c('span', {
    attrs: {
      "href": "#/html/13_7__Age_of_Bronze__State_of_Grace#page_162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 7")]), _vm._v(": in "), _c('em', [_vm._v("Novel: A Forum on Fiction")]), _vm._v(" 34, no. 1 (2000): 98–121, copyright "), _c('em', [_vm._v("©")]), _vm._v(" Novel Corp 2001. Some paragraphs of "), _c('a', {
    attrs: {
      "href": "#/html/07_1__Modernist_Form_and_the_Ethics#page_1"
    }
  }, [_vm._v("chapter 1")]), _vm._v(" were first published in “Literary Form and the Demands of Politics: Otherness in J. M. Coetzee’s "), _c('em', [_vm._v("Age of Iron")]), _vm._v(",” copyright "), _c('em'), _vm._v("© by Derek Attridge as reprinted from "), _c('em', [_vm._v("Aesthetics and Ideology")]), _vm._v(", ed. George Levine, copyright "), _c('em'), _vm._v("© 1994 by Rutgers, The State University, and are reprinted by permission of Rutgers University Press.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-537fb390","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_Acknowledgments.vue
// module id = 72
// module chunks = 0